import { render, staticRenderFns } from "./SectionTournamentFormat.vue?vue&type=template&id=f12c7932&"
import script from "./SectionTournamentFormat.vue?vue&type=script&lang=js&"
export * from "./SectionTournamentFormat.vue?vue&type=script&lang=js&"
import style0 from "./SectionTournamentFormat.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports